import ApiManager from '../../utils/ApiManager'
import Constants from '../../utils/Constants'

const state = {
  list: {
    loading: false,
    totalItems: 0,
    rowsPerPage: 20,
    headers: [
      { text: '企業名', align: 'left', value: 'contract_name' },
      { text: 'サービス区分', align: 'left', value: 'pos_flag' },
      { text: '契約ユーザー数', align: 'left', value: 'user_count' },
      { text: '月間分析回数合計', align: 'left', value: 'monthly_analyze_count', sortable: false },
      { text: '月間分析従量合計', align: 'left', value: 'monthly_analyze_usage', sortable: false },
      { text: '分析予約件数合計', align: 'left', value: 'reservation_count', sortable: false },
      { text: '分析履歴件数合計', align: 'left', value: 'all_analyze_count', sortable: false },
      { text: '有効開始日', align: 'left', value: 'active_from', sortable: false },
      { text: '有効終了日', align: 'left', value: 'active_to', sortable: false },
      { text: '最終更新日', align: 'left', value: 'modified', sortable: false },
      { text: '更新者', align: 'left', value: 'editor_name', sortable: false }
    ],
    items: [],
    menuHeader: { text: '操作', align: 'center', sortable: false, value: 'menuItems', type: 'menu', width: '80px' },
    menuItems: [
      { label: '編集', value: 'edit', kind: 'edit' },
      { label: 'ユーザー追加', value: 'user_add', kind: 'edit' }
    ]
  },
  message: {
    content: '',
    type: ''
  },
  searchCondition: {
    freeword: '',
    isActive: '1'
  }
}

const actions = {
  /**
   * 企業一覧データ取得
   */
  async getContractList ({ state, commit }, { pageNo, rowsPerPage, sortField, sortType, freeword, isActive }) {
    commit('setListLoading', true)
    commit('setSearchCondition', {
      freeword: freeword,
      isActive: isActive
    })
    const response = await ApiManager.request('Contract').contractListAdmin(
      isActive,
      pageNo,
      rowsPerPage,
      sortField,
      sortType ? '-' : null,
      freeword
    )
    const message = {
      type: 'success',
      content: ''
    }
    if (response.data.code === Constants.ResponseCode.SUCCESS) {
      commit('setList', response.data)
    } else if (response.data.code === Constants.ResponseCode.VALIDATE_ERROR) {
      message.type = 'error'
      message.content = response.data.data.message
    }
    commit('setMessage', message)
  },

  /**
   * delete
   */
  async deleteContract ({ state, commit }, deleteIds) {
    commit('setListLoading', true)
    const response = await ApiManager.request('Contract').contractDelete(deleteIds)
    if (response.data.code === 200000) {
    } else {
      commit('setMessage', { content: response.data.data.message, type: 'error' })
      commit('setListLoading', false)
    }
    this.dispatch('loading/loadingPageMinus')
  }
}

const mutations = {
  setMessage (state, data) {
    state.message = data
  },
  setSearchCondition (state, data) {
    state.searchCondition = data
  },
  setListLoading (state, data) {
    // Listローディング状態
    state.list.loading = data
    this.dispatch('loading/loadingPagePlus')
  },
  setList (state, data) {
    state.list.items = data.data
    state.list.totalItems = data.meta.count
    state.list.loading = false
    this.dispatch('loading/loadingPageMinus')
  },
  afterDeleted (state, data) {
    this.dispatch('loading/loadingPageMinus')
    this.getContractList({
      pageNo: 1,
      rowsPerPage: null,
      sortField: null,
      sortType: null,
      freeword: state.searchCondition.freeword,
      isActive: state.searchCondition.isActive
    })
  }
}

export default {
  namespaced: true,
  state,
  actions,
  mutations
}
